<template lang="pug">
.white-box
  h3.box-title.m-b-0 公開設定
  p.text-muted.m-b-30.font-13
    .row
      .col-sm-12.col-xs-12
        .form-group
          label(for='公開状態') 公開状態
          .row
            .col-md-3
              el-select(v-model='formdata.status')
                el-option(value='draft', label='未公開（下書き）')
                el-option(value='wait', label='承認依頼') 
                el-option(value='open', label='公開')
                el-option(value='close', label='公開終了')
            .col-md-4
              el-button(v-if='formdata.status === "wait"', v-on:click='onDialogAgreeList', round='') 承認依頼
              el-button(v-if='formdata.status === "open" && formdata.waiting === true', type='warning') 公開待ち
        .form-group(v-if='formdata.agree_list.length > 0')
          label(for='承認を依頼したスタッフ') 承認を依頼したスタッフ
          el-table(:data='formdata.agree_list')
            el-table-column(property="staff_id" label="ID" width="150")
            el-table-column(property="department" label="部署" width="200")
            el-table-column(property="staff_name" label="名前")
            el-table-column(property="result_view" label="結果")
        .form-group
          label(for='登録日時') 登録日時
          el-input(v-model='formdata.created_at', :disabled='true')
        .form-group
          label(for='更新日時') 更新日時
          el-input(v-model='formdata.updated_at', :disabled='true')
        .form-group
          label(for='公開予定日時') 公開予定日時
          .row
            .col-md-4
              el-date-picker(type='date', value-format='yyyy-MM-dd', v-model='formdata.open_date', placeholder='YYYY-MM-DD')
            .col-md-4
              el-time-select(v-model='formdata.open_time', placeholder='HH:MM', :picker-options="{ start: '00:00', step: '00:10', end: '23:00'}")
        .form-group
          label(for='公開終了日時') 公開終了日時
          .row
            .col-md-4
              el-date-picker(type='date', value-format='yyyy-MM-dd', v-model='formdata.close_date', placeholder='YYYY-MM-DD')
            .col-md-4
              el-time-select(v-model='formdata.close_time', placeholder='HH:MM', :picker-options="{ start: '00:00', step: '00:10', end: '23:00'}")
        div(style='margin: 20px 0')
          el-button(v-on:click="register") 登録
        el-dialog(title="依頼リスト",:visible.sync='dialogAgreeListVisible')
          el-table(:data='formdata.staff_list', @selection-change='handleSelectionChange')
            el-table-column(type="selection", width="55")
            el-table-column(property="staff_id" label="staff_id" width="150")
            el-table-column(property="department" label="department" width="200")
            el-table-column(property="staff_name" label="staff_name")
          div(style='margin-top: 20px')
            el-button(@click='onAgreeRequest') 依頼
            el-button(@click='onAgreeCancel') キャンセル
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      directionlist: [],
      checkList: [],
      dialogAgreeListVisible: false,
      openWaiting: false
    }
  },
  props: {
    apiname: String,
    formdata: Object
  },
  created () {
    this.directionlist = []
    if (!this.$route.query.id) {
      this.getStaffList()
    }
  },
  mounted () {
    // if (this.formdata.status === 'open' && moment(this.formdata.open_at).isAfter(moment())) {
    // this.openWaiting = this.isWaiting()
    console.log(this.formdata)
  },
  methods: {
    handleSelectionChange (val) {
      this.checkList = val
    },
    onDialogAgreeList (e) {
      this.dialogAgreeListVisible = true
    },
    onAgreeRequest (e) {
      this.formdata.agree_list = this.checkList
      this.dialogAgreeListVisible = false
    },
    onAgreeCancel (e) {
      this.dialogAgreeListVisible = false
    },
    getStaffList () {
      return axios({
        method: 'get',
        url: 'admin/swan/staff',
        baseURL: process.env.API_BASE_URL
      }).then((res) => {
        var _data = res.data
        this.formdata.staff_list = _data.staff_list
      }).catch(function (error) {
        this.$message({
          type: 'error',
          message: error
        })
        console.log(error)
      })
    },
    register (e) {
      let inputData = JSON.stringify(this.formdata)
      // console.log(inputData.entry_id)
      axios({
        baseURL: process.env.API_BASE_URL,
        url: '/admin/swan/' + this.apiname + '/edit',
        method: 'post',
        data: {
          data: inputData
        }
      })
        .then((response) => {
          if (this.formdata.entry_id === '' || this.formdata.entry_id === undefined) {
            this.formdata.entry_id = response.data.entry_id
          }
          this.$message({
            type: 'success',
            message: 'completed'
          })
        })
        .catch((error) => {
          this.$message({
            type: 'info',
            message: 'no completed'
          })
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/components/swan/common/PublicSetting.vue